import { render, staticRenderFns } from "./SideBarPromotion.vue?vue&type=template&id=3043631a"
import script from "./SideBarPromotion.vue?vue&type=script&lang=js"
export * from "./SideBarPromotion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports